
<div mat-dialog-content>
  <p>Create a new language draft...</p>
  <mat-form-field>
    <mat-label>Languages</mat-label>
    <mat-select 
        [(ngModel)]="data.language">
        <mat-option 
          *ngFor="let language of languages"
        [value]="language">{{language.name}}</mat-option>
        </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button [mat-dialog-close]="data.language" cdkFocusInitial>Create</button>
</div>
